import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StepperDataService {
    currenlytStep: number = 0;
    futureStep: number = 1;
    actualStep: string[] = ['Verificación número', 'Validación identidad', 'Firma contrato', 'Resumen'];
    nextStep: string[] = ['Validación identidad', 'Firma contrato', 'Resumen', 'Firma contrato'];

    updateSteps(actualStep: string[], nextStep: string[]): void {
        this.actualStep = actualStep;
        this.nextStep = nextStep;
    }

    lengthActualStep(): number {
        return this.actualStep.length;
    }

    updateStepsFromRoutingData(stepperData: { actualStep: string[], nextStep: string[] }): void {
        this.actualStep = stepperData.actualStep;
        this.nextStep = stepperData.nextStep;
    }


    // Nueva función para establecer el valor de currenlytStep
    setCurrentStep(step: number): void {
        this.currenlytStep = step;
    }

    // Nueva función para establecer el valor de futureStep
    setFutureStep(step: number): void {
        this.futureStep = step;
    }

    // Nueva función para obtener el valor de currenlytStep
    getCurrentStep(): number {
        return this.currenlytStep;
    }

    // Nueva función para obtener el valor de futureStep
    getFutureStep(): number {
        return this.futureStep;
    }
}
